import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsTextsService } from './edit-dialogs-texts.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-texts',
  templateUrl: './edit-dialogs-texts.component.html',
  styleUrls: ['./edit-dialogs-texts.component.css']
})
export class EditDialogsTextsComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%', height: '150%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsTextsService: EditDialogsTextsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsTextsService>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsTextsService.build(); }

  ngOnInit() {
    this.editDialogsTextsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Texts
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsTextsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del text está ausente
      // -1: El número del text ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorTexts('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorTexts('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog texts
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let text = this.editDialogsTextsService.text;
    let original = this.editDialogsTextsService.originalTexts;
    return this.editDialogsTextsService.compare(text, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorTexts(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
